module.exports = __webpack_public_path__ + "src/assets/img/hxjs_jsjg_03@2x.1d5e8ad9.png";